import { Skeleton, Typography } from '@mui/material';
import React from 'react';

const FakeForm = () => (
	<div data-testid="fake-form">
		<Typography variant="h1">
			<Skeleton animation="wave" width="100%" />
		</Typography>
		<br />
		<Typography variant="body1">
			<Skeleton animation="wave" width="30%" />
		</Typography>
		<Typography variant="h2">
			<Skeleton animation="wave" width="100%" />
		</Typography>{' '}
		<br />
		<Typography variant="body1">
			<Skeleton animation="wave" width="28%" />
		</Typography>
		<Typography variant="h2">
			<Skeleton animation="wave" width="100%" />
		</Typography>{' '}
		<br />
		<Typography variant="body1">
			<Skeleton animation="wave" width="35%" />
		</Typography>
		<Typography variant="h2">
			<Skeleton animation="wave" width="100%" />
		</Typography>
		<br />
		<Typography variant="body1">
			<Skeleton animation="wave" width="28%" />
		</Typography>
		<Typography variant="h2">
			<Skeleton animation="wave" width="100%" />
		</Typography>
		<br />
		<Typography variant="body1">
			<Skeleton animation="wave" width="35%" />
		</Typography>
		<Typography variant="h2">
			<Skeleton animation="wave" width="100%" />
		</Typography>
	</div>
);

export default FakeForm;
